import React from 'react';

import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { connect } from 'react-redux';
import { ApplicationState } from '../../../redux/reducers';
import { removeToast } from '../../../redux/ui/creators';
import { createPropertySignature } from 'typescript';
function Alert(props: any) {
  return <MuiAlert elevation={6} variant={props.severity ? 'filled' : 'standard'} {...props} />;
}

interface StateProps {
  toasts: any;
}
interface RequiredProps {
  children?: JSX.Element;
}
interface OptionalProps {
  removeToast: any;
}
type Props = StateProps & RequiredProps & OptionalProps;

const Toaster = (props: Props) => {

  const handleClose = (id: any) => {
    props.removeToast(id);
  };
  return (
    props.toasts.map((toast: any, index: any) => {
      return (
        <div className="toaster" key={index}>
          <Snackbar 
            key={index}
            open={true}
            autoHideDuration={6000}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          >
            <Alert onClose={() => handleClose(toast.id)} severity={toast.type}>
              {toast.message}
            </Alert>
          </Snackbar>
        </div>
      )
    })
    
  );
}

export default connect<any, any, any>(
  (state: ApplicationState | any) => {
    return {
      toasts: state.ui.toasts
    };
  },
  (dispatch: any) => {
    return {
      removeToast: dispatch(removeToast)
    }
  },
)(Toaster);
